/*
 * Filter memory for /invoices (table + board) and /credit-notes.
 *
 * Only URL-backed keys can be listed here. On both pages `search`, the column
 * sort and the column funnels live in component/hook state, not the URL, so
 * they are not listed — they ARE remembered, by `useTableFilters` (table
 * memory, `filterMemoryState`; owner 2026-10-23: the sort persists on the
 * account), not by this rule. Never listed: `new` (opens the create dialog
 * on /invoices) and the page number (component state).
 */
import type { FilterMemoryRule } from './types';

export const FILTER_MEMORY_INVOICES_CREDIT: readonly FilterMemoryRule[] = [
  {
    path: '/invoices',
    keep: [
      'view', // table (key absent) vs board
      'statusId', // invoice status filter
      'contactId', // contact filter
      'companyId', // company filter (also locks the create form when paired with new=1)
      'dealId', // deal filter
      'quoteId', // source quote filter
      'accountLeadId', // account lead filter (also written by the default-lead hook)
      'projectId', // project filter
      'lineProjectId', // multi-project filter, CSV of ids
      'billDateAfter', // bill date lower bound (inclusive)
      'billDateBefore', // bill date upper bound (inclusive)
      'currency', // currency code filter
    ],
  },
  {
    path: '/credit-notes',
    keep: [
      'companyId', // company filter
      'contactId', // contact filter
      'sourceInvoiceId', // invoice the note was raised from
      'allocatedToInvoiceId', // invoice the note is allocated to
      'creditNoteDateAfter', // credit note date lower bound (inclusive)
      'creditNoteDateBefore', // credit note date upper bound (inclusive)
      'currency', // currency code filter
      'spendable', // only spendable notes (true flag)
      'hasBalance', // only notes with a remaining balance (true flag)
      'importedFromXero', // imported from Xero: true / false
    ],
  },
];
